// One-off foreground location reading for clock-in/out geofence checks. Never watches or tracks.
export const newEventId = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `ev_${Date.now()}_${Math.random().toString(36).slice(2)}`);

export const readLocationOnce = () => new Promise((resolve) => {
  if (!navigator.geolocation) { resolve({ location_error: "unsupported" }); return; }
  navigator.geolocation.getCurrentPosition(
    (p) => resolve({ location: { lat: p.coords.latitude, lng: p.coords.longitude, accuracy_m: p.coords.accuracy, captured_at: new Date(p.timestamp).toISOString() } }),
    (e) => resolve({ location_error: e.code === 1 ? "denied" : e.code === 3 ? "timeout" : "unavailable" }),
    { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 },
  );
});

export const RESULT_LABEL = {
  inside: "Inside the site area", outside: "Outside the site area", uncertain: "Location uncertain (accuracy too low or near the boundary)",
  stale: "Location reading too old", unavailable: "Location unavailable or permission denied", no_location: "No location sent (older app)",
};
